import { render, staticRenderFns } from "./AccountGoogle.vue?vue&type=template&id=832204d8&scoped=true&"
import script from "./AccountGoogle.vue?vue&type=script&lang=js&"
export * from "./AccountGoogle.vue?vue&type=script&lang=js&"
import style0 from "./AccountGoogle.vue?vue&type=style&index=0&id=832204d8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "832204d8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/admin/workspace/ss/ss-web-game/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('832204d8')) {
      api.createRecord('832204d8', component.options)
    } else {
      api.reload('832204d8', component.options)
    }
    module.hot.accept("./AccountGoogle.vue?vue&type=template&id=832204d8&scoped=true&", function () {
      api.rerender('832204d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/social/AccountGoogle.vue"
export default component.exports